export var EAudioPlayback;
(function (EAudioPlayback) {
    EAudioPlayback[EAudioPlayback["Undefined"] = 0] = "Undefined";
    EAudioPlayback[EAudioPlayback["Playing"] = 1] = "Playing";
    EAudioPlayback[EAudioPlayback["Paused"] = 2] = "Paused";
    EAudioPlayback[EAudioPlayback["Idle"] = 3] = "Idle";
})(EAudioPlayback || (EAudioPlayback = {}));
export var EMusicPlayingRepeatStatus;
(function (EMusicPlayingRepeatStatus) {
    EMusicPlayingRepeatStatus[EMusicPlayingRepeatStatus["None"] = 0] = "None";
    EMusicPlayingRepeatStatus[EMusicPlayingRepeatStatus["All"] = 1] = "All";
    EMusicPlayingRepeatStatus[EMusicPlayingRepeatStatus["Once"] = 2] = "Once";
    EMusicPlayingRepeatStatus[EMusicPlayingRepeatStatus["Max"] = 3] = "Max";
})(EMusicPlayingRepeatStatus || (EMusicPlayingRepeatStatus = {}));
